import { httpClient } from "./http-client";
import type { ApiResponse } from "../../shared/types/api";

export interface VerifyEmailResponse {
  success: boolean;
  reason?: string;
}

export interface EmailVerificationStatusResponse {
  emailVerified: boolean;
  maskedEmail?: string;
}

const MES_EMAIL_VERIFICATION_ENDPOINTS = {
  VERIFY_EMAIL: "/api/mes/auth/verify-email",
  RESEND_VERIFICATION: "/api/mes/auth/resend-verification",
  VERIFICATION_STATUS: "/api/mes/auth/verification-status",
} as const;

class EmailVerificationApiService {
  /**
   * 이메일 인증 (토큰으로)
   */
  async verifyEmail(token: string): Promise<VerifyEmailResponse> {
    const response = await httpClient.get<ApiResponse<VerifyEmailResponse>>(
      `${MES_EMAIL_VERIFICATION_ENDPOINTS.VERIFY_EMAIL}?token=${encodeURIComponent(token)}`
    );
    return response.data.data ?? { success: false };
  }

  /**
   * 인증 이메일 재발송
   */
  async resendVerificationEmail(): Promise<boolean> {
    const response = await httpClient.post<ApiResponse<boolean>>(
      MES_EMAIL_VERIFICATION_ENDPOINTS.RESEND_VERIFICATION
    );
    return response.data.data ?? false;
  }

  /**
   * 이메일 인증 상태 조회
   */
  async getVerificationStatus(): Promise<EmailVerificationStatusResponse> {
    const response = await httpClient.get<
      ApiResponse<EmailVerificationStatusResponse>
    >(MES_EMAIL_VERIFICATION_ENDPOINTS.VERIFICATION_STATUS);
    return response.data.data ?? { emailVerified: false };
  }
}

export const emailVerificationApiService = new EmailVerificationApiService();
